import client from "@/lib/api";

const q = (o) => Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== "").map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
export const brainSummary = () => client.get("/brain/summary").then((r) => r.data);
export const brainActions = (params) => client.get(`/brain/actions?${q(params)}`).then((r) => r.data);
export const brainAction = (id) => client.get(`/brain/actions/${id}`).then((r) => r.data);
export const brainDecide = (id, body) => client.post(`/brain/actions/${id}/decide`, body).then((r) => r.data);
export const brainReviewQueue = () => client.get("/brain/review-queue").then((r) => r.data);
export const brainEvents = (params = {}) => client.get(`/brain/events?${q(params)}`).then((r) => r.data);
export const brainCollect = () => client.post("/brain/collect").then((r) => r.data);
export const brainAutonomy = () => client.get("/brain/autonomy").then((r) => r.data);
export const brainDecisions = () => client.get("/brain/decisions").then((r) => r.data);
export const brainGraph = (exam) => client.get(`/brain/graph?${q({ exam })}`).then((r) => r.data);
export const brainAffected = (source) => client.get(`/brain/graph/affected?${q({ source })}`).then((r) => r.data);
export const brainAudit = () => client.get("/brain/audit").then((r) => r.data);
export const brainFlags = () => client.get("/brain/flags").then((r) => r.data);
export const brainSetFlags = (flags) => client.put("/brain/flags", { flags }).then((r) => r.data);
export const brainCaps = () => client.get("/brain/capabilities").then((r) => r.data);
export const brainSetCaps = (capabilities) => client.put("/brain/capabilities", { capabilities }).then((r) => r.data);

export const RISK = {
  CRITICAL: "bg-rose-100 text-rose-700 border-rose-200", HIGH: "bg-orange-100 text-orange-700 border-orange-200",
  MEDIUM: "bg-amber-100 text-amber-700 border-amber-200", LOW: "bg-emerald-100 text-emerald-700 border-emerald-200",
};
export const STATUS_CLS = {
  WAITING_REVIEW: "bg-blue-50 text-blue-700", PROPOSED: "bg-slate-100 text-slate-700", APPROVED: "bg-emerald-50 text-emerald-700",
  REJECTED: "bg-rose-50 text-rose-700", APPLIED: "bg-violet-50 text-violet-700", VERIFIED: "bg-emerald-100 text-emerald-800",
  DETECTED: "bg-slate-50 text-slate-600", RESEARCHING: "bg-amber-50 text-amber-700", ROLLED_BACK: "bg-slate-200 text-slate-700",
};
export const PERM_LABEL = { AUTO: "Auto", AUTO_AFTER_TRAINING: "Training", HUMAN_REVIEW: "Human review", HUMAN_ONLY: "Human only" };
